import request from '@/config'
import { useAppStoreWithOut } from '@/store/app'

/* Types */
import { CpContactSearch, CpContactIns, CpContactEdt } from './cp.contact.type';

const appStore = useAppStoreWithOut()

/* 相对方：联系人信息列表 */
export const CpContactListApi = (searchDto: CpContactSearch): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const loginInfo: LoginBase =
    {
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id,
    }

    const search = Object.assign({}, loginInfo, searchDto)

    return request.post({ url: '/api/counterpartcontact/getcounterpartcontactpage', data: search })
}

/* 相对方：联系人信息详细 */
export const CpContactInfoApi = (rowID: string): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const loginInfo: LoginBase =
    {
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id,
    }

    const search = Object.assign({}, loginInfo, { id: rowID })

    return request.post({ url: '/api/counterpartcontact/getcounterpartcontactinfo', data: search })
}


/* 相对方：删除联系人 */
export const CpContactDelApi = (delRow: any): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const delInfo: DeleteDto =
    {
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id,
        deleted_user_id: login.user_id,
        id: delRow.id,
        revision: delRow.revision
    }

    return request.post({ url: '/api/counterpartcontact/deletecounterpartcontact', data: delInfo })
}

/* 相对方：创建联系人 */
export const CpContactInsApi = (searchDto: CpContactIns): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const loginInfo: LoginBase =
    {
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id,
    }

    const creation = Object.assign({}, loginInfo, searchDto)

    return request.post({ url: '/api/counterpartcontact/insertcounterpartcontact', data: creation })
}


/* 相对方：修改联系人 */
export const CpContactEdtApi = (editIpt: CpContactEdt): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const editInfo: UAccountInfo =
    {
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id,
        updated_user_id: login.user_id
    }

    const editorData = Object.assign({}, editInfo, editIpt)

    return request.post({ url: '/api/counterpartcontact/updatecounterpartcontact', data: editorData })
}